module.exports = __webpack_public_path__ + "static/6p-3-948bd7bbeb4567b2848ff23d50c6350b.jpg";